@if (isSelf) {
  <div class="mt-2 main-panel border border-dark p-3 rounded-3" data-test="ui-defaults-section">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-12 col-md-8">
          <h6 class="m-0 mb-1">New transaction experience</h6>
          <small class="my-0 text-muted">
            A preview of the redesigned transaction pages, so you may notice some issues.
            @if (!hasChosen) {
              <span>You haven't chosen yet, so your account's default applies.</span>
            }
          </small>
        </div>
        <div class="col-12 col-md-4">
          <div class="d-flex justify-content-md-end mt-2 mt-md-0">
            <mat-slide-toggle
              color="primary"
              data-test="ui-defaults-new-experience-toggle"
              [checked]="newTransactionExperience === true"
              [disabled]="loading"
              (change)="setNewTransactionExperience($event.checked)">
            </mat-slide-toggle>
          </div>
        </div>
      </div>
    </div>
  </div>
}
